import { focusMe } from "./focus-me";
import { sdFocusOut } from "./focus-out";
import { keyboardActivation } from "./keyboardActivation";
import { noFocusOnClick } from "./no-focus-on-click";
import { sdOutsideClickOrTab } from "./outside-click-or-tab";
import { repeatDoneDirective } from "./repeat-done";
import { scrollIfDirective } from "./scroll-if";
import { selectRange } from "./select-range";
import eaeControlsModule from "../eaeControls.module";

eaeControlsModule
  .directive("focusMe", focusMe)
  .directive("sdFocusOut", sdFocusOut)
  .directive("keyboardActivation", keyboardActivation)
  .directive("noFocusOnClick", noFocusOnClick)
  .directive("sdOutsideClickOrTab", sdOutsideClickOrTab)
  .directive("repeatDone", repeatDoneDirective)
  .directive("scrollIf", scrollIfDirective)
  .directive("selectRange", selectRange);
